import { apiCadastro } from './utils/api';

export const postDeclaracao = async (clientInfo) => {
  if (!navigator.onLine) {
    return null;
  }

  const response = await apiCadastro.post(`/api/DuplaCategoria`, clientInfo);
  return response;
};